import React, { useEffect, useMemo, useState } from "react";
import { SalesFilterBar } from "./Components/SalesFilterBar";
import { SalesReport } from "./Components/SalesReport";
import {
  getCategories,
  getInvoices,
  getSales,
  getSalesAgents,
  getStores,
} from "../../lib/mockSales";
import { useQuery } from "@tanstack/react-query";
import { ErrorDialog } from "../../components/ui/notification";
import { fetchItemBalApi } from "../../api/fetchItemBalApi";

/** @param {{ report:string }} args */
const SalesComponent = ({ report }) => {
  const [salesMonths, setSalesMonths] = useState(12);
  // const [salesCompare, setSalesCompare] = useState("mom");
  const [salesStore, setSalesStore] = useState("all");
  const [category, setCategory] = useState("all");
  const [salesagent, setSalesAgent] = useState("all");
  //(useState < "all") | "Active" | ("Inactive" > "all");
  const [tick, setTick] = useState(0);

  const [dismissed, setDismissed] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const oneYearAgo = useMemo(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
  }, []);
  const firstOfMonth = useMemo(() => {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() - 2);
    // if (d.getMonth() === 0) {
    //   d.setFullYear(d.getFullYear() - 1);
    //   d.setMonth(11);
    // } else {
    //   what if is month feb
    //   month jan is 0
    //   d.setMonth(d.getMonth() - 2);
    // }
    return d.toISOString().split("T")[0];
  }, []);

  const [startDate, setStartDate] = useState(firstOfMonth);
  const [endDate, setEndDate] = useState(today);

  const {
    data: stores = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["stores", tick],
    queryFn: getStores,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: salesAgents = [],
    isLoading: isLoadingSalesAgents,
    isError: isErrorSalesAgents,
  } = useQuery({
    queryKey: ["salesagents", tick],
    queryFn: getSalesAgents,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: categories = [],
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQuery({
    queryKey: ["categories", tick],
    queryFn: getCategories,
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: sales = [],
    isLoading: isLoadingSales,
    isError: isErrorSales,
  } = useQuery({
    // queryKey: ["sales", tick],
    // queryFn: getSales,
    queryKey: ["sales", tick, startDate, endDate],
    queryFn: () => getSales({ startDate, endDate }),
    staleTime: 1000 * 60 * 15,
  });

  const {
    data: invoices = [],
    isLoading: isLoadingInvoices,
    isError: isErrorInvoices,
  } = useQuery({
    // queryKey: ["sales", tick],
    // queryFn: getSales,
    queryKey: ["invoices", tick, startDate, endDate],
    queryFn: () => getInvoices({ startDate, endDate }),
    staleTime: 1000 * 60 * 15,
  });

  const queryErrors = useMemo(() => {
    const errors = [
      {
        key: "stores",
        label: "Stores",
        isError: isError,
        error: "Error Loading Stores",
      },
      {
        key: "categories",
        label: "Stock Categories",
        isError: isErrorCategories,
        error: "Error Loading Item Categories",
      },
      {
        key: "sales",
        label: "Sales",
        isError: isErrorSales,
        error: "Error Loading Sales",
      },
      {
        key: "invoice",
        label: "Invoices",
        isError: isErrorInvoices,
        error: "Error Loading Invoices",
      },
      {
        key: "salesAgents",
        label: "Sales Agents",
        isError: isErrorSalesAgents,
        error: "Error Loading Sales Persons",
      },
    ];

    return errors
      .filter((e) => e.isError)
      .map((e) => ({
        key: e.key,
        message: `${e.error}`,
      }));
  }, [
    isErrorSales,
    isError,
    isErrorCategories,
    isErrorSalesAgents,
    isErrorInvoices,
  ]);

  const errorSignature = queryErrors.map((e) => e.key).join(",");
  useEffect(() => {
    // console.log("errors");
    setDismissed(false);
  }, [errorSignature]);

  const filterSales = useMemo(() => {
    return sales.filter((m) => {
      if (salesStore !== "all" && m.storecode !== Number(salesStore))
        return false;
      if (salesagent !== "all" && m.salesagentcode !== Number(salesagent))
        return false;
      return true;
    });
  }, [salesStore, salesagent, sales]);

  const filterInvoices = useMemo(() => {
    return invoices.filter((m) => {
      if (salesagent !== "all" && m.salesagentcode !== Number(salesagent))
        return false;
      return true;
    });
  }, [salesagent, invoices]);

  return (
    <>
      {(isLoading ||
        isLoadingCategories ||
        isLoadingSales ||
        isLoadingSalesAgents ||
        isLoadingInvoices) && (
        <div className="loading-div">
          <div className="spinner"></div>
        </div>
      )}

      <ErrorDialog
        errors={dismissed ? [] : queryErrors}
        onClose={() => setDismissed(true)}
      />

      <SalesFilterBar
        // months={salesMonths}
        // setMonths={setSalesMonths}
        // compare={salesCompare}
        // setCompare={setSalesCompare}
        report={report}
        today={today}
        oneYearAgo={oneYearAgo}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        store={salesStore}
        setStore={setSalesStore}
        stores={stores}
        category={category}
        setCategory={setCategory}
        categories={categories}
        salesagent={salesagent}
        setSalesAgent={setSalesAgent}
        salesAgents={salesAgents}
        onRefresh={() => setTick((t) => t + 1)}
      />

      <section className="pbi-canvas">
        <SalesReport
          report={report}
          months={salesMonths}
          startDate={startDate}
          endDate={endDate}
          store={salesStore}
          salesagent={salesagent}
          //
          stores={stores}
          salesagents={salesAgents}
          categories={categories}
          // sales={sales}
          // invoices={invoices}
          sales={filterSales}
          invoices={filterInvoices}
        />
      </section>
    </>
  );
};

export default SalesComponent;
